<template>
  <div class="footer">
    <footer>
      <div class="top">
        <div class="left">
          <div class=" dfc mb20">
            <img src="../../assets/logo2.png" alt="" class="mr10" /><span class="logoText">| 电商企业智能工具平台</span>
          </div>
          <div style="margin-top:40px;" class="mb20 service">
            <router-link to="/contactUs" class="color777 mr40">联系我们</router-link>
            <a
              href="https://mp.weixin.qq.com/mp/homepage?__biz=MzI0MDY3ODkxNA==&hid=9&sn=17b06891a1caa65a70722e0720047ee1"
              target="_blank"
              class="color777"
            >
              帮助中心</a
            >
          </div>
          <div class="friendLink">
            <p class="color777 mr10">友情链接：</p>
            <a
              href="https://pc.1688.com/product/detail.htm?spm=a262g2.8722258.0.0.lXW1O3&productCode=icI2kcc3ZyKlqxXP5fpZTDiRE8IN7W9bIEFx7k9zkZs%3D&productType=GROUP&type=koyqlj"
              target="_blank"
              @click.stop="buryingpoint('快哦友情--商机助理')"
              >大泽商机助理</a
            >
            <a
              href="https://pc.1688.com/product/detail.htm?spm=a262g2.8722258.0.0.fmu9oE&productCode=Nnyly1ubYcxw7GADRiN6CAroZWlVC4%2FImHi%2F84Wj%2FJE%3D&productType=GROUP&type=koyqlj"
              target="_blank"
              @click.stop="buryingpoint('快哦友情--慧眼识货')"
              >大泽慧眼识货</a
            >
            <a
              href="https://pc.1688.com/product/detail.htm?spm=a262g2.8722258.0.0.P1VNrc&productCode=DzV2uTDayCumIT%2FuSICtR8UChjOY8hWuDoOtBggEz2Q%3D&productType=GROUP&type=koyqlj"
              target="_blank"
              @click.stop="buryingpoint('快哦友情--大泽_店长工具')"
              >大泽_店长工具</a
            >
          </div>
        </div>
        <div class="right">
          <div class="telePhone">
            <i class="iconfont icondianhua"></i>
            <p>177-5912-6083</p>
            <p>工作日08:30-21:00</p>
          </div>
          <div class="wechat tc">
            <p>
              <img src="../../assets/wechat.jpg" alt="" style="width:80px" />
            </p>
            <div class="font12 colorfff mt10">
              关注微信公众号
            </div>
          </div>
        </div>
      </div>
      <div class="bottom">
        <div>总部：福建.福州西洪路528号金牛山互联网产业园3#10层</div>
        <div class="dfcjsb">
          <p>
            <a href="http://beian.miit.gov.cn" style="color: #777;" target="_blank" rel="noopener noreferrer">
              ©2015-2020福建大泽网络科技有限公司 版权所有 闽ICP备15016648号-15 增值电信业务经营许可证：闽B2-20180149</a
            >
          </p>
          <p>
            <img src="../../assets/beian.png" alt="" />
            闽公网安备 35010202000243号
          </p>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  updated() {},
  mounted() {},
  methods: {
    buryingpoint(data) {
      let pointData = {
        functionTypeName: data,
        callback: (resp) => {},
      };
      this.$utils.buryingpoint(pointData);
    },
  },
};
</script>

<style lang="scss" scoped>
.footer {
  background: #050d16;
  footer {
    width: 1360px;
    height: 280px;
    margin: 0 auto;
    .top {
      height: 186px;
      border-bottom: 1px solid #333333;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .right {
      display: flex;
      /* align-items: center; */
      justify-content: space-between;
      width: 300px;
      .telePhone {
        text-align: center;
        i {
          background: #22282e;
          color: #fff;
          border-radius: 50%;
          padding: 20px;
          font-size: 26px;
          display: inline-block;
          height: 66px;
          line-height: 1;
        }
        p:nth-child(2) {
          color: #fff;
          font-size: 24px;
          margin: 10px 0;
        }
        p:nth-child(3) {
          color: #fff;
          font-size: 12px;
        }
      }
      .wechat {
        p {
          padding: 10px;
          background: #fff;
        }
      }
    }
    .logoText {
      color: #777;
    }
    .service {
      a {
        color: #777;
      }
      a:hover {
        color: #fff;
      }
    }
    .friendLink {
      display: flex;
      align-items: center;
      a {
        color: #777;
        margin: 0 20px;
      }
      a:hover {
        color: #fff;
      }
    }
    .bottom {
      margin-top: 10px;
      color: #777;
      font-size: 12px;
      height: 40px;
      line-height: 25px;
    }
  }
}
@media screen and (max-width: 1440px) {
  .footer {
    footer {
      width: 1200px !important;
    }
  }
}
</style>
